import React, { Component } from 'react';

import UserModel from './UserModel';
import UserForm from './UserForm';
import { defaultSorter, dateSorter } from './Helpers';
import { Table, Popconfirm, Typography, Row, Col, List, Divider, message } from 'antd';

class UserTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    userSettingsFormData: null,
  }
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row>
          <Col span={8}>
            <List size="small"
              header={<div>Role</div>}
              bordered
              dataSource={record.roles}
              renderItem={item => <List.Item>{item}</List.Item>}
            />
          </Col>
          <Col span={8}>
            <List size="small"
              header={<div>Města</div>}
              bordered
              dataSource={record.citiesNames}
              renderItem={item => <List.Item>{item.name}</List.Item>}
            />
          </Col>
          <Col span={8}>
            <List size="small"
              header={<div>Parkoviště</div>}
              bordered
              dataSource={record.locationsNames}
              renderItem={item => <List.Item>{item.name}</List.Item>}
            />
          </Col>
        </Row>
      </div >
    );
  }

  render() {
    const columns = [{
      title: 'Celé jméno',
      dataIndex: 'name',
      key: 'name',
      width: 250,
      sorter: (a, b) => defaultSorter(a.name, b.name),
      defaultSortOrder: 'ascend',
    }, {
      title: 'Uživ. jméno',
      dataIndex: 'username',
      key: 'username',
      width: 200,
      sorter: (a, b) => defaultSorter(a.username, b.username),
    }, {
      title: 'Akce',
      key: 'Action',
      width: 100,
      render: (text, record) => {
        if (record.username !== 'admin' && UserModel.isInRoles(['ADMIN', 'SYSTEM_USERS_WRITE'])) {
          return (
            <div>
              <Divider type="vertical" />
              <a onClick={(e) => {
                this.setState({
                  userSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow(record.id)
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      },
    }]


    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          onChange={this.handleChange}
          dataSource={this.props.data}
          expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }} />
        <UserForm
          type="modal"
          modalVisible={this.state.userSettingsFormData === null ? false : true}
          initialValues={this.state.userSettingsFormData}
          onSuccess={(form, values) => {
            UserModel.patch(this.state.userSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  userSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }}
          onModalCancel={() => {
            this.setState({ userSettingsFormData: null });
          }}
        />
      </div>
    );
  }
}

export default UserTable;


// WEBPACK FOOTER //
// ./src/components/UserTable.js